<template>
  <div class="">
    <b-modal
      ref="modal-primary2"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      title="Rapor Detayı"
      hide-footer
    >
      <div id="invoice-page">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>
        <div id="printMe2">
          <vx-card id="invoice-container" style="padding: 25px">
            <!-- INVOICE METADATA -->
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td class="p-2">
                  <img class="" v-bind:src="logoUrl" alt="algolia-logo" />
                </td>
                <td style="padding: 10px; text-align: right">
                  <h6>Sipariş Numarası</h6>
                  <p>{{ orderNumber }}</p>
                  <h6>Fatura Tarihi:</h6>
                  <p>{{ getNow() }}</p>
                </td>
              </tr>
            </table>

            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td
                  style="
                    width: 50%;
                    padding-top: 25px;
                    text-align: left;
                    padding-bottom: 25px;
                    border-bottom: solid;
                  "
                >
                  <div style="padding-bottom: 25px">
                    <h6>
                      Satıcı |
                      {{ satici }}
                    </h6>

                    <h6>
                      Satıcı Adres |
                      {{ saticiAdres }}
                    </h6>
                    <h6>
                      Alıcı |
                      {{ act }}
                    </h6>
                    <h6>
                      Alıcı Adres |
                      {{ actAdres }}
                    </h6>

                    <h6>
                      Vergi Dairesi |
                      {{ taxnumber }}
                    </h6>
                    <h6>
                      Vergi Dairesi |
                      {{ taxnumb }}
                    </h6>
                  </div>
                </td>
              </tr>
            </table>

            <br />
            <br />
            <table
              style="border-top: 1px solid grey; width: 100%"
              class="border-collapse"
            >
              <tr>
                <td>
                  <table style="width: 100% !important; text-align: center">
                    <tr>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        GRUP
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        BARKOD
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        STOK ADI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        RENK
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        BEDEN
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        İÇERİK
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ADET
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TOPTAN SATIŞ FİYATI (KDV HARİÇ)
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TOPTAN SATIŞ FİYATI (KDV DAHİL)
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TOPTAN SİPARİŞ TUTARI (KDV HARİÇ)
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TOPTAN SİPARİŞ TUTARI (KDV DAHİL)
                      </th>
                    </tr>

                    <tr :key="indextr" v-for="(tr, indextr) in productDetail">
                      <td style="padding: 8px">
                        {{ tr.grup }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.maddeKodu }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.maddeAciklamasi }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.renkAciklamasi }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.BEDEN }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.icerik }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.MIKTAR }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.FIYAT }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.FIYATKDV }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.TUTAR }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.TUTARKDV }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          text-align: right;
                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          border-left: 1px solid grey;

                          padding: 8px;
                        "
                      >
                        {{ toplamAdet }}
                      </td>
                      <td style="padding: 8px"></td>

                      <td style="padding: 8px"></td>

                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          text-align: right;
                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          border-left: 1px solid grey;

                          padding: 8px;
                        "
                      >
                        {{ toplamSipTutar }}
                      </td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          text-align: right;
                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          border-left: 1px solid grey;

                          padding: 8px;
                        "
                      >
                        {{ toplamSipTutarKDV }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <br />
            </table>

            <br />
   <!--         <table>
              <tr>
                <td>
                  <h5>ŞARTLAR</h5>
                  <p>1- Toplam siparişteki miktarın toleransı +/- 10%'dur.</p>
                  <p>
                    2- Etiket ve paketleme: Buldan's etiketli. Çoklu paketleme.
                  </p>
                  <p>
                    3- Teslimat detayları: 01.04.2023 Tarihinden itibaren
                    başlayacak, 30.06.2023 tarihinde son bulacaktır. 10.000 TL
                    ve üstü kargolarda Nakliye ve sigorta alıcıya aittir.
                  </p>
                  <p>
                    4- Ödeme şekli: %50'si işbu sözleşmenin tebliğine istinaden
                    peşin ve kalan 50% mal tesliminden 60 gün sonra ………...………
                    tarihinde TL bazında banka havalesiyle peşin ödenecektir.
                  </p>
                  <p>
                    5- Vadesinde yapılmayan ödemelerde, aylık % 9 faiz
                    işletilir.
                  </p>
                  <p>
                    6- İşbu siparişin verilmesi ile alıcı taraf, satın aldığı
                    ürünlerin bedellerinin vadesi hakkında ihtar edilmiş olur.
                    Karşı taraf, vade tarihinde borcunu ödemediği takdirde
                    kendisine ek bir ihtar yapılması gerekmeksizin temerrüde
                    düşer ve satıcı temerrüt faizine hak kazanır. (TTK 1530/2)
                  </p>
                  <p>
                    7- İş bu belge taraflar arasındaki mutakabat sonucunda
                    oluşturulan nihai sözleşmedir. Alıcı siparişin durumunda ve
                    adetlerinde, modellerde değişiklik yapamaz. Ancak bazı
                    durumlarda satıcının yazılı onayına istinaden değişiklikler
                    satıcı insiyatifinde kabul edilebilir.
                  </p>
                  <p>
                    8- Alıcı, iş bu sözleşme ile satıcının sipariş konusu
                    ürünleri üretime başlayacağını, ham madde teminini
                    yapacağını ve üretim planlamasını bu sipariş doğunda
                    güncellediğini bilmektedir. Sipariş konusu ürünleri almaktan
                    hiçbir koşulda vazgeçmeyeceğini, sözleşmeden dönmeyeceğini,
                    bu maddeye aykırı davranması halinde ya da ilerleyen süreçte
                    siparişin bir kısmını almaktan vazgeçmesi halinde verilen
                    kaparonun yanacağını, hiçbir şekilde geri istenemeyeceğini,
                    ayrıca satıcının doğacak tüm zararlarını karşılayacağını
                    peşinen kabul ve taahhüt etmiştir.
                  </p>
                  <p>
                    9- Alıcı tarafından satıcıya bu sözleşmenin imzalanmasından
                    sonra 4. Maddedeki bedel ödenir. 1. Madde uyarınca sipariş
                    iptali mümkün değildir.
                  </p>
                  <p>
                    10- Malın teslimi sonrasında, gizli ayıp haricinde, malda
                    bir eksiklik ya da ayıp bulunması durumunda, alıcı 15 gün
                    içerisinde bu durumu satıcıya bildirecektir. Teslimden
                    itibaren 15 gün sonrasında teslim edilen ürünler bu neden
                    ile iade edilemeyecek, gizli ayıp haricinde ihbarda
                    bulunulamayacaktır.
                  </p>
                  <p>
                    11- İş bu proforma faturada yer alan birim fiyatları
                    15.01.2023 tarihine kadar toplam sipariş bedelinin nakden ve
                    peşinen ödenmesi halinde geçerlidir. Proforma fatura
                    geçerlilik tarihi olan 15.01.2023 tarihinden sonra toptan
                    fiyatlar mevcut piyasa koşullarına göre değişebilir. Bu
                    tarihe kadar alıcı siparişinde değişiklik yapabilir.
                    Değişiklik eğer satıcının politikalarına aykırı ise satıcı
                    siparişi tek taraflı olarak iptal edebilir.
                  </p>
                  <p>
                    12- 09.03.2023 tarihine kadar toplam sipariş bedeli nakden
                    ödenmemiş siparişlerde sabit fiyat garantisi
                    sunulmayacaktır.
                  </p>
                  <p>
                    13- 15.01.2023 tarihine kadar nakden ödemesi yapılmamış
                    siparişler için satıcı sevkiyatlara başlamadan önce
                    25.03.2022 tarihinde proforma faturadaki ürünler için toptan
                    fiyat listesi yayınlanacaktır. Bu listede piyasa şartları
                    gereği toptan ve tavsiye edilen perakende fiyatlar
                    değişiklik gösterebilir. 25.03.2023 listesine göre
                    siparişteki ürünlerin fiyatları değişebilir. Alıcı bu durumu
                    peşinen kabul etmektedir.
                  </p>
                  <p>
                    14- Satıcı değişen fiyat listelerinde, alıcının toptan ve
                    tavsiye edilen perakande fiyatlar arasındaki birim kar
                    marjını korumayı tahahhüt eder.Bu birim kar marjları
                    14.12.2022 tarihli fiyat listelerindeki marjlardır.
                  </p>

                  <p>
                    15- Mücbir sebep halleri olan yangın,sel, deprem, salgın
                    hastalık,doğal afetler kaynaklı işletmede ve tedarik
                    zincirinde işlerin kısmen ve tamamiyle yapılamaması halinde
                    teslimat tarihleri revize edilebilir. Bunu alıcı peşinen
                    kabul etmiştir.
                  </p>
                  <p>
                    16- İhtilaf halinde Denizli Mahkemeleri ve İcra Daireleri
                    yetkilidir.
                  </p>
                </td>
              </tr>
            </table>
            <table
              style="
                font-weight: bold;
                border-top: 1px solid grey;
                text-align: right;
                border-bottom: 1px solid grey;
                border-right: 1px solid grey;
                border-left: 1px solid grey;

                padding: 8px;
              "
            >
              <tr
                style="
                  font-weight: bold;
                  border-top: 1px solid grey;
                  text-align: right;
                  border-bottom: 1px solid grey;
                  border-right: 1px solid grey;
                  border-left: 1px solid grey;

                  padding: 8px;
                "
              >
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  BANKA:
                </td>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  T. VAKIFLAR BANKASI T.A.O.
                </td>
              </tr>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  ŞUBE:
                </td>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  DENIZLI – SARAYKÖY ŞUBESİ
                </td>
              </tr>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  HESAP SAHİBİ:
                </td>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  DÖNMEZ EV TEKSTİLİ VE GİYİM SANAYİ A.Ş.
                </td>
              </tr>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  IBAN:
                </td>
                <td
                  style="
                    font-weight: bold;
                    border-top: 1px solid grey;
                    text-align: right;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    border-left: 1px solid grey;

                    padding: 8px;
                  "
                >
                  TR74 0001 5001 5800 7314 6893 61
                </td>
              </tr>
            </table>
            <br />
            <br />
            <table style="width: 100%">
              <tr>
                <td></td>
                <td>Satıcı</td>
                <td>Alıcı</td>
              </tr>
            </table>-->
            <br />
            <br />
            <!-- INVOICE FOOTER -->
          </vx-card>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  <script>
import Store from "../../../store/store";
import jsonData from "../../../../public/user.json";
export default {
  name: "SiparisDetayButton",
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],

  data() {
    return {
      actAdres: "",
      act: "",
      saticiAdres: "",
      satici: "",
      logoUrl: "",
      barcodeValue: "",
      orderNumber: "",
      program: "",
      productDetail: [],

      shipFullAddress: "",
      shipFullName: "",
      shipCity: "",
      shipDistrict: "",

      quantityPrice: 0,
      grossAmount: 0,
      totalDiscount: 0,
      totalPrice: 0,

      invoiceFullAddress: "",
      invoiceFullName: "",
      telefon: 0,
      customerEmail: "",

      cargoProviderName: "",
      cargoTrackingNumber: "",
      discount: 0,

      mailTo: "",
      invoiceDistrict: "",
      invoiceCity: "",

      viewCheck: false,
      popupKartDetay: false,
      musteriId: "",
      imageSrc: "",
      serialNumber: "",
      taxnumber: "",
      taxnumb: "",

      toplamAdet: "",
      topBAKIYE: "",
      toplamSipTutar: "",
      toplamSipTutarKDV: "",
    };
  },
  created() {
    this.logoUrl = Store.state.logoUrl;
  },
  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe2");
    },
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    printInvoice() {
      window.print();
    },

    siparisDetayCek(
      productValue,
      refno,
      act,
      adres,
      taxnumber,
      toplamAdet,
      toplamSipTutar,
      toplamSipTutarKDV,
      taxnumb
    ) {
      console.log(productValue);

      var vm = this;
      this.$refs["modal-primary2"].show();
      vm.orderNumber = refno;
      vm.productDetail = productValue;
      vm.satici = jsonData.excelSatici;
      vm.saticiAdres = jsonData.excelSaticiAdres;
      vm.act = act;
      vm.actAdres = adres;
      vm.taxnumber = taxnumber;
      vm.toplamAdet = toplamAdet;
      vm.toplamSipTutar = toplamSipTutar;
      vm.toplamSipTutarKDV = toplamSipTutarKDV;
      vm.taxnumb = taxnumb;
    },
  },

  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
  // mounted(){this.siparisDetay()}
};
</script>
  <style lang="scss">
.con-vs-popup .vs-popup {
  width: 850px;
}
.vs-table--tbody-table {
  min-width: 0px;
}
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
  